import $ from 'jquery';
import 'jquery-validation';


var remainingFields = 11;
$(".c-form1__steptxt, .c-scrolltop__txtform").text("未入力項目が" + remainingFields + "項目あります");
const form_validation = $('#mw_wp_form_mw-wp-form-158 form');
$.validator.addMethod("customPhoneFormat", function (value, element) {
  return this.optional(element) || /^(\d{10}|\d{3}-\d{3}-\d{4})$/.test(value);
});
$.validator.addMethod("customCodeFormat", function (value, element) {
  return this.optional(element) || /^(\d{7}|\d{3}-\d{4})$/.test(value);
});

form_validation.validate({
  rules: {
    "question": {
      required: true,
    },
    "company": {
      required: true,
    },
    "company_furigana": {
      required: true,
    },
    "name": {
      required: true,
    },
    "name_furigana": {
      required: true,
    },
    "post-code": {
      required: true,
      customCodeFormat: true
    },
    "prefectures": {
      required: true,
    },
    "municipalities": {
      required: true,
    },
    "address": {
      required: true,
    },
    "phone": {
      required: true,
      customPhoneFormat: false,
    },
    "email": {
      required: true,
      email: true
    },
    "privacy[data][]": {
      required: true
    },
  },
  messages: {
    "question": {
      required: "※お問い合わせカテゴリーを選択してください。",
    },
    "company": {
      required: "※貴社名を入力してください。",
    },
    "company_furigana": {
      required: "※貴社名（フリガナ）を入力してください。",
    },
    "name": {
      required: "※お名前を入力してください。",
    },
    "name_furigana": {
      required: "※お名前（フリガナ）を入力してください。",
    },
    "post-code": {
      required: "※郵便番号を入力してください。",
      number: "※郵便番号の形式ではありません。",
      customCodeFormat: "※郵便番号の形式ではありません。"
    },
    "prefectures": {
      required: "※都道府県を選択してください。",
    },
    "municipalities": {
      required: "※市区町村を入力してください。",
    },
    "address": {
      required: "※町名・番地を入力してください。",
    },
    "phone": {
      required: "※電話番号を入力してください。",
    },
    "email": {
      required: "※メールアドレスを入力してください。",
      email: "※メールアドレスの形式ではありません。"
    },
    "privacy[data][]": {
      required: "※ご同意いただけない場合は送信ができません。"
    }
  },
  errorPlacement: function (error, element) {
    if (element.attr("name") == "post-code") {
      error.appendTo(".is-postcoded");
    } else {
      error.insertAfter(element);
    }
  },
  onkeyup: function (element) {
    this.element(element);
    checknumber();
  },
});

document.querySelector('.is-search-address').addEventListener('click', function (event) {
  var zip = document.querySelector('.is-postcode input').value;
  event.preventDefault();
  if (zip) {
    new YubinBango.Core(zip, function (addr) {
      var region1 = addr.region;
      var locality1 = addr.l;
      var streetAddress1 = addr.m;
      document.querySelector('.is-prefectures select').value = region1;
      document.querySelector('.is-municipalities input').value = locality1;
      document.querySelector('.is-address input').value = streetAddress1;
      form_validation.validate().element('select[name=prefectures]');
      form_validation.validate().element('[name=municipalities]');
      form_validation.validate().element('[name=address]');
      checknumber();
    });
  }
  return false;
});


$('.is-select1').change(function () {
  form_validation.validate().element('.is-select1');
  checknumber();
  if ($(this).val() === "採用に関するお問い合わせ") {
    $(this).parents('.c-form1__content').find('input[name="company"]').parents('.c-form1__item').addClass('is-none');
    $(this).parents('.c-form1__content').find('input[name="company_furigana"]').parents('.c-form1__item').addClass('is-none');
  } else {
    $('.c-form1__item').removeClass('is-none');
  }
});

if ($('.is-select1').val() === "採用に関するお問い合わせ") {
  $('.is-select1').parents('.c-form1__content').find('input[name="company"]').parents('.c-form1__item').addClass('is-none');
  $('.is-select1').parents('.c-form1__content').find('input[name="company_furigana"]').parents('.c-form1__item').addClass('is-none');
} else {
  $('.c-form1__item').removeClass('is-none');
}


$('.is-select2').change(function () {
  form_validation.validate().element('.is-select2');
  checknumber();
});

$(".is-search-address").click(function () {
  form_validation.valid();
});

function checknumber() {
  var question = 1,
    company = 1,
    company_furigana = 1,
    name = 1,
    name_furigana = 1,
    postcode = 1,
    prefectures = 1,
    municipalities = 1,
    address = 1,
    phone = 1,
    email = 1;
  if ($('.is-select1').val() === "採用に関するお問い合わせ") {
    company = 0, company_furigana = 0;
  }
  if ((!$('#question-error').length || $('#question-error').text() === '') && !$('select[name="question"] option:first-child').is(':selected')) {
    question = 0;
  }
  if ((!$('#company-error').length || $('#company-error').text() === '') && $('input[name="company"]').val() !== '') { company = 0; }
  if ((!$('#company_furigana-error').length || $('#ccompany_furigana-error').text() === '') && $('input[name="company_furigana"]').val() !== '') { company_furigana = 0; }
  if ((!$('#name-error').length || $('#name-error').text() === '') && $('input[name="name"]').val() !== '') { name = 0; }
  if ((!$('#name_furigana-error').length || $('#name_furigana-error').text() === '') && $('input[name="name_furigana"]').val() !== '') { name_furigana = 0; }
  if ((!$('#post-code-error').length || $('#post-code-error').text() === '') && $('input[name="post-code"]').val() !== '') { postcode = 0; }
  if ((!$('#prefectures-error').length || $('#prefectures-error').text() === '') && !$('select[name="prefectures"] option:first-child').is(':selected')) {
    prefectures = 0;
  }
  if ((!$('#municipalities-error').length || $('#municipalities-error').text() === '') && $('input[name="municipalities"]').val() !== '') { municipalities = 0; }
  if ((!$('#address-error').length || $('#address-error').text() === '') && $('input[name="address"]').val() !== '') { address = 0; }
  if ((!$('#phone-error').length || $('#phone-error').text() === '') && $('input[name="phone"]').val() !== '') { phone = 0; }
  if ((!$('#email-error').length || $('#email-error').text() === '') && $('input[name="email"]').val() !== '') { email = 0; }
  var total = question + company + company_furigana + name + name_furigana + postcode + prefectures + municipalities + address + phone + email;
  $(".c-form1__steptxt, .c-scrolltop__txtform").text("未入力項目が" + total + "項目あります");
}

checknumber();
